module.exports = __webpack_public_path__ + "media/images/costumes/top/dress/thumbnail-9-93473865f0118ad4c6441d807fb89ec8.jpg";